import request from './request'

// 采集列表
export function captureGetList(params) {
  return request({
    url: '/capture/list',
    method: 'get',
    params
  })
}

// 删除采集数据
export function captureDelete(data) {
  return request({
    url: '/capture/batch-delete',
    method: 'post',
    data
  })
}

// 保存到素材
export function captureBatchSave(data) {
  return request({
    url: '/capture/batch-save-to-file',
    method: 'post',
    data
  })
}

// 导出数据
export function captureExportExcel(data) {
  return request({
    url: '/capture/export',
    method: 'post',
    data
  })
}

// 按模板导出数据
export function captureExport(data) {
  return request({
    url: '/capture/generateExcel',
    method: 'post',
    data
  })
}
